import React, { FC } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import theme from 'src/theme/light';

const useStyles = makeStyles({
  buttonRoot: {
    padding: 0
  },
  defaultBotaoCategoria: {
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white'
    }
  },
  selectedBotaoCategoria: {
    backgroundColor: theme.palette.primary.main,
    color:  'white',
  },
  unselectedBotaoCategoria: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.grey[600],
  }
})

export interface OptionButton {
    id: number;
    nome: string;
}

export interface AttributesButton {
    nome: string;
    options: OptionButton[];
    handleClickButton?: Function;
    active: boolean;
    tipoCategoria: number;
}

const FilterButtonComponentes: FC<AttributesButton> = ({
    nome,
    options,
    handleClickButton = () => {},
    active = false,
    tipoCategoria,
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const classes = useStyles();

  const handleClick = () => {
    if (handleClickButton) {
      handleClickButton(options.map((opt)=> {return opt.id}), nome, "Todos", tipoCategoria);
    }
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setOpen(false);
    if (handleClickButton) {
        const current = options[index].id;
        if (current) {
          handleClickButton([current], nome, options[index].nome, tipoCategoria);
        } else {
          handleClickButton(options.map((opt)=> {return opt.id}), nome, "Todos", tipoCategoria);
        }
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event?: MouseEvent | TouchEvent) => {
    const target = event?.target as HTMLElement | null;
    if (anchorRef.current && anchorRef.current.contains(target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
        <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
          <Button className={`${classes.defaultBotaoCategoria} ${active ? classes.selectedBotaoCategoria : classes.unselectedBotaoCategoria}`} onClick={handleClick}>{nome}</Button>
          <Button
            className={`${classes.defaultBotaoCategoria} ${active ? classes.selectedBotaoCategoria : classes.unselectedBotaoCategoria}`}
            color="primary"
            size="small"
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper style={{ zIndex: isMobile ? 20 : undefined }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    {options.map((option, index) => (
                      <MenuItem
                        key={option.nome}
                        selected={index === selectedIndex}
                        dense
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option.nome}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
    </>
  );
}

export { FilterButtonComponentes }
